<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_EVALUATE" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"EVALUATION_STATUS" | translate | titlecase}}</label>
                    <p class="cand-answer">{{candData.acceptanceStatus }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"EVALUATION_COMMENT" | translate | titlecase}}</label>
                    <p class="cand-answer">{{candData.acceptanceComment }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"EVALUATION_DATE" | translate | titlecase}}</label>
                    <p class="cand-answer">{{candData.acceptanceDate | date:'yyyy-MM-dd' }}</p>
                </div>
               
    
            </div>
        </div>
    </div>
    </div>
    <app-loader [show]="!checkDataExist()"></app-loader>